import Mutations from '../../odata/mutations';

export default { ...new Mutations('bannedUser'), ...new Mutations('bannedUsers') };
